import { render, staticRenderFns } from "./questionBank.vue?vue&type=template&id=75b27ba4&scoped=true"
import script from "./questionBank.vue?vue&type=script&lang=js"
export * from "./questionBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b27ba4",
  null
  
)

export default component.exports